const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const HeavyHelmet = require('../../../game_items/equipment/helmet/HeavyHelmet.js');
const HeavyTorsoe = require('../../../game_items/equipment/torsoe/HeavyTorsoe.js');
const HeavyBoots = require('../../../game_items/equipment/boots/HeavyBoots.js');
const Dagger = require('../../../game_items/equipment/weapon/Dagger.js');
const Shield = require('../../../game_items/equipment/off_hand/Shield.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const ratling_warrior = (level) => {
  const handle = 'ratling_warrior';
  const types = ['beast', 'rat', 'tanky'];
  const AI_PRIORITIES = ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'];
  const bags = [
    {
      items: [
        ItemGenerator.getCavernsMobItem(HeavyHelmet, level),
        ItemGenerator.getCavernsMobItem(HeavyTorsoe, level),
        ItemGenerator.getCavernsMobItem(HeavyBoots, level),
        ItemGenerator.getCavernsMobItem(Dagger, level),
        ItemGenerator.getCavernsMobItem(Shield, level),
      ].map((item) => ({ value: item })),
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'ratling_warrior_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          quickness: {
            handle: 'quickness',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          shield_block: {
            handle: 'shield_block',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(3 + bound_level * 0.45 + Math.random() * 3),
      perception: Math.round(4 + bound_level * 0.65 + Math.random() * 3),
      mana: Math.round(3 + bound_level * 0.35 + Math.random() * 3),
      toughness: Math.round(2 + bound_level * 0.3 + Math.random() * 3),
      strength: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      willpower: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      dexterity: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 200,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }, { value: 'shield_block' }],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = ratling_warrior;
